import type { WidgetConstructorName } from "./shared/types/widgetConstructorName";

export const REAL_HTML_TOP_HEIGHT = 50;
export const REAL_HTML_PADDING_X = 100;
export const REAL_HTML_PADDING_Y = 50;

export const WIDTH_MULTIPLIER_FOR_HIGHLIGHTER = 3;

export const MIN_TEXT_SIZE = 2;
export const MAX_TEXT_SIZE = 999;

// максимальный размер изображения 32 мегабайт
export const MAX_IMAGE_SIZE = 32 * 1024 * 1024;
export const MAX_IMAGE_SIZE_READABLE = "32 МБ";
export const MAX_IMAGE_WIDTH = 8192;
export const MAX_IMAGE_HEIGHT = 4096;
export const MAX_IMAGE_DOWNLOAD_COUNT = 50; // максимум картинок можно грузить за раз
export const IMAGE_FORMATS = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/svg",
    "application/pdf",
];
export const IMAGE_FORMATS_READABLE = ["gif", "jpeg", "png", "svg", "pdf"];
export const IMAGE_PREVIEW_PARAM_KEY = "preview";
export const IMAGE_LOAD_BORDER_COLOR = "#777777";
export const IMAGE_LOAD_LIMIT = 50;

export const SHOW_COMMENTS_LS_KEY = "showComments";
export const SHOW_RESOLVED_COMMENTS_LS_KEY = "showResolvedComments";
export const SHOW_VOTES_RESULTS_LS_KEY = "showVotesResults";

export const CONSTRUCTORS_WITHOUT_ANCHORS = ["comment", "arrow"];

export const AI_ASSISTANT_SUPPORTED_WIDGETS: WidgetConstructorName[] = [
    "sticker",
    "table",
    "textV2",
    "shape",
];
